import React from "react";
import "../../../../stylesheets/components/Reports/HoldingReports/SmcasePopupFail.scss";
import downloadFail from "../../../../assets/images/Reports/downloadFail.svg";
import downloadPopup from "@frameworks/web/assets/images/Reports/common/download-popup.svg";
import { useNavigate, useParams } from "react-router-dom";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
const PopupFail = (props) => {
    const navigate = useNavigate();
    const { loginOrigin } = useParams();
    const setUrl = () => {
        const destination = ".." +
            getLoginSourceURL(loginOrigin) +
            "?reportName=" +
            props.pageName.replace(/\s&/g, "") +
            (props.tabName ? "&tab=" + props.tabName : "");
        navigate(destination, { replace: true });
    };
    return (React.createElement("div", { className: "smallcase-popup-fail" },
        React.createElement("div", { className: "smallcase-popup-fail-head" },
            React.createElement("i", { className: "edel-icon-download1 download" }),
            React.createElement("p", null,
                (props === null || props === void 0 ? void 0 : props.isDownloadIcon) ? (React.createElement(React.Fragment, null,
                    React.createElement("img", { src: downloadPopup, className: "pe-2" }))) : (""),
                props.hasOwnProperty("isDownload") && (props === null || props === void 0 ? void 0 : props.isDownload)
                    ? "Download"
                    : "",
                "\u00A0",
                props.Title,
                " ",
                !props.reportText && "Report")),
        React.createElement("div", { className: "smallcase-popup-fail-body text-center" },
            React.createElement("img", { className: "downloadSuccess", src: downloadFail, alt: "downloadFail" }),
            props.message ? (React.createElement("label", { className: "update-message" },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: props.message } }))) : (React.createElement("label", { className: "update-message" },
                "We ran into some technical difficulties with",
                props.operation == "email_download" ? " email/ download" : null,
                props.operation == "email" ? " email functionality" : null,
                props.operation == "download" ? " download functionality" : null,
                ", please try again!")),
            React.createElement("span", { className: "action-post-success" },
                React.createElement("button", { onClick: () => {
                        var _a;
                        if (props === null || props === void 0 ? void 0 : props.sendBack) {
                            (_a = props === null || props === void 0 ? void 0 : props.goBack) === null || _a === void 0 ? void 0 : _a.call(props);
                        }
                        else {
                            setUrl();
                        }
                        // window.location.reload();
                        props.setDownloadFail(false);
                        setTimeout(() => {
                            var _a;
                            (_a = props === null || props === void 0 ? void 0 : props.closeDropdown) === null || _a === void 0 ? void 0 : _a.call(props, false);
                        }, 0);
                    } },
                    React.createElement("i", { className: "edel-icon-left-shortArrow twist" }),
                    props.goBackText ? "Go Back" : `Go Back To ${props.pageName}`)))));
};
export default PopupFail;
